export default "__VITE_ASSET__C1Skypjb__"